import EventCard from "./EventCard";

export default function EventCardList({ events }) {
    return (
        <div>
            {events.map(event => (
                <EventCard key={event.id} name={event.name} dateTime={event.start_time} venue={event.venues[0]} event={event}/>
            ))}
          </div>
    )
}